// @ts-nocheck

import { fetchRequest, initialFetchListParams } from './index';
import isArray from 'lodash/isArray';
const convertDataToServer = data => {
  return {
    ...data,
    certificationAreas: isArray(data.certificationAreas) ? data.certificationAreas : data.certificationAreas ? [data.certificationAreas] : null
  };
};
export const fetchDocument = id => {
  const document = fetchRequest.get(`/document/${id}`);
  if (document) return document;
  throw new Error('Не удалось загрузить документ');
};
export const fetchDocuments = async (params = initialFetchListParams) => await fetchRequest.get('/document', {
  ...initialFetchListParams,
  ...params
});
export const deleteDocument = async id => {
  const deleted = await fetchRequest.delete(`/document/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить документ');
};
export const updateDocument = async employeeDocument => {
  const updated = await fetchRequest.put('/document', convertDataToServer(employeeDocument));
  if (updated) return updated;
  throw new Error('Не удалось обновить документ');
};
export const addDocument = async employeeDocument => {
  const added = await fetchRequest.post('/document', convertDataToServer(employeeDocument));
  if (added) return added;
  throw new Error('Не удалось обновить документ');
};
export default {
  fetchDocument,
  fetchDocuments,
  deleteDocument,
  updateDocument,
  addDocument
};
